import { Injectable } from '@angular/core';
import { PscHttpService } from "./psc-http.service";
import { map, Observable } from "rxjs";
import { SupplierName } from "../common/models/price/supplier-name";
import { TariffModel } from "../common/models/price/tariff-model";
import { CalculatorPrivacyStatus } from '../common/models/price/calculator-privacy-status';
import { Price } from '../common/models/price/price';

@Injectable({
  providedIn: 'root',
})
export class PriceService {

  baseEndpoint = 'price/';

  constructor(
    private httpService: PscHttpService,
  ) {
  }


  getSuppliers(country: string, calculatorPrivacyStatus: CalculatorPrivacyStatus): Observable<SupplierName[]> {
    return this.httpService.get(`${ this.baseEndpoint }supplierName?country=${ country }&privacyStatus=${ calculatorPrivacyStatus }`).pipe(
      map(models => models as unknown as SupplierName[]),
    );
  }

  getTariffModels(country: string, supplier: string, calculatorPrivacyStatus: CalculatorPrivacyStatus): Observable<TariffModel[]> {
    return this.httpService.get(`${ this.baseEndpoint }tariffName?country=${ country }&name=${ supplier }&privacyStatus=${ calculatorPrivacyStatus }`).pipe(
      map(models => models as unknown as TariffModel[]),
    );
  }

  getPrices(type: 'private' | 'public'): Observable<Price[]> {
    return this.httpService.get(`${ this.baseEndpoint }${ type }`);
  }

  addPrice(price: Price): Observable<Price> {
    return this.httpService.post(`${ this.baseEndpoint }`, price);
  }

  updatePrice(price: Price): Observable<Price> {
    return this.httpService.put(`${ this.baseEndpoint }`, price);
  }

  getPrice(priceId: string): Observable<Price> {
    return this.httpService.get(`${ this.baseEndpoint }${ priceId }`);
  }

  deletePrice(priceId: string) {
    return this.httpService.delete(`${ this.baseEndpoint }${ priceId }`);
  }
}
